import {useState} from "react";
import {Text1} from "../../../../styles/business-components";
import * as S from './styles'

import MessengerImage1 from '../../../../assets/images/business/b_func_messenger_img1.png'
import MessengerImage2 from '../../../../assets/images/business/b_func_messenger_img2.png'
import UpdatesImage1 from '../../../../assets/images/business/b_func_updates_img1.png'
import UpdatesImage2 from '../../../../assets/images/business/b_func_updates_img2.png'
import VideoImage1 from '../../../../assets/images/business/b_func_video_img1.png'
import VideoImage2 from '../../../../assets/images/business/b_func_video_img2.png'
import DiskImage1 from '../../../../assets/images/business/b_func_disk_img1.png'
import SupportImage1 from '../../../../assets/images/business/b_func_support_img1.png'
import SupportImage2 from '../../../../assets/images/business/b_func_support_img2.png'

const menuItems = [
    {title: 'Мессенджер', key: 'messenger'},
    {title: 'Автообновление', key: 'updates'},
    {title: 'Видеоконференции', key: 'video'},
    {title: 'Диск', key: 'disk'},
    {title: 'Отклик тех. поддержки', key: 'support'},
    {title: 'Функционал администратора', key: 'admin'},
];

export const Functional = () => {
    const [active, setActive] = useState('messenger');

    return (
        <S.Container>
            <S.Title>Функционал</S.Title>
            <Text1>
                Представляем вашему вниманию ключевые особенности и преимущества нашего сервиса,
                которые делают его незаменимым инструментом для вашего бизнеса и общения.
            </Text1>
            <S.TabsBox>
                <S.Content>
                    <S.Item active={active === 'messenger'}>
                        <S.ItemTextBlock>
                            <S.ItemTitle>
                                Общайтесь с коллегами{'\n'}
                                без использования{'\n'}
                                сторонних приложений
                            </S.ItemTitle>
                            <S.ItemText>
                                Прост, удобен и готов к работе с первого клика. Все необходимые функции находятся в
                                вашем распоряжении без ограничений.
                            </S.ItemText>
                            <S.ItemText>
                                Работать в TeleGuard Business так же легко, как и с популярными мессенджерами.
                            </S.ItemText>
                        </S.ItemTextBlock>
                        <S.ItemImageBlock>
                            <S.ItemImage src={MessengerImage1}/>
                            <S.ItemImage src={MessengerImage2}/>
                        </S.ItemImageBlock>
                    </S.Item>
                    <S.Item active={active === 'updates'}>
                        <S.ItemTextBlock>
                            <S.ItemTitle>Сконцентрируйтесь на важном, а не на актуальности TeleGuard</S.ItemTitle>
                            <S.ItemText>Все происходит автоматически, и вам не придется беспокоиться. </S.ItemText>
                            <S.ItemText> TeleGuard всегда в курсе актуальных нововведений, обновляясь незаметно для вас.</S.ItemText>
                        </S.ItemTextBlock>
                        <S.ItemImageBlock>
                            <S.ItemImage src={UpdatesImage1}/>
                            <S.ItemImage src={UpdatesImage2}/>
                        </S.ItemImageBlock>
                    </S.Item>
                    <S.Item active={active === 'video'}>
                        <S.ItemTextBlock>
                            <S.ItemTitle>Обсуждайте рабочие вопросы лицом к лицу из любой точки мира</S.ItemTitle>
                            <S.ItemText>
                                Организуйте видеоконференции даже для больших групп.
                                В зависимости от вашего тарифа, участвовать могут до 100 человек.
                            </S.ItemText>
                        </S.ItemTextBlock>
                        <S.ItemImageBlock>
                            <S.ItemImage src={VideoImage1}/>
                            <S.ItemImage src={VideoImage2}/>
                        </S.ItemImageBlock>
                    </S.Item>
                    <S.Item active={active === 'disk'}>
                        <S.ItemTextBlock>
                            <S.ItemTitle>Храните все необходимые файлы в одном месте</S.ItemTitle>
                            <S.ItemText>Выбирая тариф, получите возможность обмена информацией до 1 Тбайт.</S.ItemText>
                            <S.ItemText>Срок хранения медиафайлов варьируется от 1 месяца до неограниченного времени.</S.ItemText>
                        </S.ItemTextBlock>
                        <S.ItemImageBlock>
                            <S.ItemImage src={DiskImage1}/>
                        </S.ItemImageBlock>
                    </S.Item>
                    <S.Item active={active === 'support'}>
                        <S.ItemTextBlock>
                            <S.ItemTitle>У вас возникли вопросы? Мы с радостью поможем</S.ItemTitle>
                            <S.ItemText>Мы всегда рядом! Готовы помочь и ответить на ваши вопросы. </S.ItemText>
                            <S.ItemText>Время ответа службы поддержки составляет от 6 до 24 часов, в зависимости от выбранного тарифа.</S.ItemText>
                        </S.ItemTextBlock>
                        <S.ItemImageBlock>
                            <S.ItemImage src={SupportImage1}/>
                            <S.ItemImage src={SupportImage2}/>
                        </S.ItemImageBlock>
                    </S.Item>
                </S.Content>
                <S.TabsMenu>
                    {
                        menuItems.map(item =>
                            <S.TabsMenuItem
                                key={item.key}
                                active={active === item.key}
                                onClick={() => setActive(item.key)}
                            >
                                {item.title}
                            </S.TabsMenuItem>)
                    }
                </S.TabsMenu>
            </S.TabsBox>
        </S.Container>
    );
}